{
  "title": "Warding Bond",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level abjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a pair of platinum rings worth at least 50 gp each, which you and target must wear for the duration)",
  "duration": "1 hour",
  "description": [
    "This spell wards a willing creature you touch and creates a mystic connection between you and the target until the spell ends.",
    "While the target is within 60 feet of you, it gains a +1 bonus to AC and saving throws, and it has resistance to all damage. Also, each time it takes damage, you take the same amount of damage.",
    "The spell ends if you drop to 0 hit points or if you and the target become separated by more than 60 feet. It also ends if the spell is cast again on either of the connected creatures. You can also dismiss the spell as an action."
  ],
  "spellLists": ["cleric", "paladin"]
}
